import { render, staticRenderFns } from "./GogoRuntimeRouterWrapper.vue?vue&type=template&id=57e6c902"
import script from "./GogoRuntimeRouterWrapper.vue?vue&type=script&lang=ts"
export * from "./GogoRuntimeRouterWrapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports